module.exports = __webpack_public_path__ + "static/media/logo-saaeoeiras.2b189aa9.png";